import { useEffect, useState } from 'react';
import { displayErrorNotification } from '../../../../../../utils/displayNudosStandardNotifications';
import { NudosSelectButton } from '../../../../../../components/NudosComponents';
import { getOrganizationData, updateOrganizationType } from '../../../../../../services/bussines';
import { CLIENT_TYPES, TClientType } from '../../../../../../types/client.types';

const ClientType = ({
  organizationId,
  updateWithoutLoaders
}: {
  organizationId: string;
  updateWithoutLoaders?: () => void;
}) => {
  const [clientType, setClientType] = useState<TClientType>(CLIENT_TYPES.CLIENT);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchOrganizationInfo = async () => {
    if (!organizationId) return;
    setLoading(true);
    try {
      const { organizationType } = await getOrganizationData(organizationId);
      const { id: organizationTypeId } = organizationType;
      setClientType(organizationTypeId as TClientType);
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateClientType = async (type: TClientType) => {
    try {
      await updateOrganizationType(+organizationId, { organizationTypeId: type });
      setClientType(type);
    } catch (error) {
      displayErrorNotification();
    } finally {
      updateWithoutLoaders?.();
    }
  };

  useEffect(() => {
    fetchOrganizationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="accountTitle">Tipo de facturación</div>
      <div className="accountOptions">
        {loading ? (
          <div className="loaderOptions animationLoader" />
        ) : (
          <>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleUpdateClientType(CLIENT_TYPES.CLIENT)}
                isButtonActive={clientType === CLIENT_TYPES.CLIENT}
              />
              <div className="optionText">Reglas estándar</div>
            </div>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleUpdateClientType(CLIENT_TYPES.PARTNER)}
                isButtonActive={clientType === CLIENT_TYPES.PARTNER}
              />
              <div className="optionText">Facturación centralizada desde Uruguay</div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientType;
